<main class="ma__form-page" id="main-content" tabindex="-1">

    <div class="container page-container" [formGroup]="viewer" >

        <div *ngIf="!(itemsCount>0); else viewer">
                <strong>No Files Found</strong>
        </div>


        <br>
        <ng-template #viewer>
            <div style="overflow:auto;max-height:400px;width:100%">
        <table  style="width:100%" class="table  table-bordered table-striped">
                        
            <thead>
                <tr>
                    <th style="cursor: pointer;" *ngFor="let column of sortableColumns" (click)="column.name !=null ? electrically_sort(column):return; ">
                        {{column.title}}
                        <span *ngIf="column.direction != null">
                            <span *ngIf="column.direction=='asc'; then sortAscending else sortDescending"></span>
                        </span>
                        </th>
                        
                        <ng-template #sortDescending>
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sort" class="svg-inline--fa fa-sort-down fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"></path></svg>
                        </ng-template>
                        
                        <ng-template #sortAscending>
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sort" class="svg-inline--fa fa-sort-up fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"></path></svg>
                        </ng-template>
                    
                </tr>
            </thead>
            <tbody>
                
                <tr  *ngFor="let item of viewerFormGroup;">
                   
                    <td>
                            {{item.rtn}}
                    </td> 
                    <td>
                        <div [innerHtml]="item.forms"></div>
                           
                    </td>
                    
                    <td>
                        {{item.submitDate | date:'M/d/y h:mm:ss a'}}
                         
                    </td>    
                    <td>
                        <div [innerHtml]="item.attachments"></div>
                           
                    </td>
                    <td>
                        <div [innerHtml]="item.notes"></div>
                           
                    </td>
                    <td>
                        {{item.depTrackingId}}
                            
                    </td>
                </tr>
            </tbody>
        </table>
            </div>
        <div class="row pagination" style="margin:20px 0;">
            <pagination [totalItems]="itemsCount" [itemsPerPage]="pageSize" [maxSize]="10" (pageChanged)="electrically_pageChanged($event)"></pagination>

           
            <div class="col-md-2 ma__select-box js-dropdown ma__select-box--optional">

                <label class="col-md-6 ma__select-box__label sr-only" aria-hidden="true" for="resultRows" style="float:left; margin-top:0;">Show Number of Rows Per Page</label>

                <div class="ma__select-box__field">
                    <select class="ma__select-box__select js-dropdown-select pagination" id="resultRows" (change)="electrically_pageCountChanged($event)" style="text-align:left;font-size:14px; color:#141414">
                        <option value="10">
                            10/Page
                        </option>
                        <option value="25">
                            25/Page
                        </option>
                        <option value="50">
                            50/page
                        </option>
                    </select>

                    <div class="ma__select-box__link pagination">
                        <span class="js-dropdown-link" style="font-size:15px; font-weight:600; color:#141414">{{pageSize}}/Page</span> <span class="ma__select-box__icon"></span>
                    </div>
                </div>
            </div>

            <div class="col-md mr-auto " style="text-align:right">{{gridPageStart}} - {{gridPageEnd}} of {{itemsCount}} items </div>
            
         
        </div>
        
        </ng-template>
        <div style="background-color: #FFFCCC;font-size: 16px;;">
            <p>The documents viewable here include all site information submitted electronically via eDEP, and many scanned paper documents. Please note that documents shown here likely represent a complete record of publicly available documents for that specific RTN. However, you may contact the appropriate regional office to confirm no additional documents exist.
            </p>
        </div>
        <div class="generic-button-group">
            <div>
                <div class="generic-button-group-left">
                    <button class="btn btn-default btn-custom" (click)="back()"><i class="fa fa-chevron-left"></i>&nbsp;Previous</button>
                </div>
                
            </div>
        </div>
        <br>
        <div class="float-right">
            <span>Please contact <a href="mailto:BWSC.eDEP@mass.gov">BWSC.eDEP@mass.gov</a> with questions.   </span><br>
            <span class="float-right">Data is updated once a day</span>
          </div>
        <ngx-spinner bdColor="rgba(51, 51, 51, 1.0)" size="default" type="ball-spin-clockwise">  
            <p style="color: white">Please Wait. </p>  
        </ngx-spinner> 
    </div>
</main>
